import React from "react";
import { CHAT_MESSAGES } from "../utils/triloChatConstants";

/**
 * TriloChatStudySelector
 *
 * Study-context picker for MW, shown both on the welcome screen and in the
 * chat header. A plain <select> rather than StudySelectDropdown because it has
 * to sit inline in the chat header at its own size, and because MW identifies
 * studies by id where that component works in study names.
 *
 * Props:
 * - label: Field label ("Study context" on the welcome screen, "Study" in the header)
 * - studies: Array of { id, name }
 * - selectedStudyId: Currently selected study id, or "" for no context
 * - onChange: (studyId: string) => void
 */
const TriloChatStudySelector = ({
  label,
  studies,
  selectedStudyId,
  onChange,
}) => {
  if (!studies.length) return null;

  return (
    <div className="trilochat__study-selector">
      <label className="trilochat__study-label">{label}</label>
      <select
        className="trilochat__study-select"
        value={selectedStudyId}
        onChange={e => onChange(e.target.value)}>
        <option value="">{CHAT_MESSAGES.noStudyContext}</option>
        {studies.map(s => (
          <option key={s.id} value={s.id}>
            {s.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default TriloChatStudySelector;
